type Props = {
  input: string;
  includedRegionCodes?: string[];
  addressTypes?: string[];
  sessionToken: google.maps.places.AutocompleteSessionToken;
};

export async function getPlacePredictions({
  input,
  includedRegionCodes,
  addressTypes,
  sessionToken,
}: Props): Promise<google.maps.places.AutocompleteSuggestion[]> {
  const { AutocompleteSuggestion } = (await google.maps.importLibrary(
    'places',
  )) as google.maps.PlacesLibrary;

  const response = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
    input,
    includedRegionCodes,
    includedPrimaryTypes: addressTypes ?? ['geocode'],
    sessionToken,
  });

  if (response?.suggestions) {
    return response.suggestions;
  } else {
    return [];
  }
}
